import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useState } from 'react';
import PricelistTree, { PricelistTreeProps } from './PricelistTree';

type Props = Omit<PricelistTreeProps, 'filter' | 'setFilter'> & {
    handleClose: () => void;
};

export const PricelistDialog = ({
    handleClose,
    multiSelect,
    showBasePricelistsOnly,
    selectedPricelistIds: initialSelectedPricelistIds,
    pricelistsSelected
}: Props) => {
    const [selectedPricelistIds, setSelectedPricelistIds] = useState(initialSelectedPricelistIds);
    const [hasSelectedPricelist, setHasSelectedPricelist] = useState(false);
    const [filter, setFilter] = useState('');

    const handlePricelistsSelected = (pricelistId: number | number[]) => {
        setSelectedPricelistIds(pricelistId);

        if (Array.isArray(pricelistId)) {
            setHasSelectedPricelist(pricelistId.length > 0);
        } else {
            setHasSelectedPricelist(pricelistId != null);
        }
    };

    const handleSubmit = () => {
        if (pricelistsSelected != null) {
            pricelistsSelected(selectedPricelistIds!);
            handleClose();
        }
    };

    return (
        <Dialog
            open={true}
            onClose={handleClose}
            scroll="paper"
            sx={{ minWidth: '250px', minHeight: '400px' }}
        >
            {/* Todo: Check if above sx must be applied on nested Paper element */}
            <DialogTitle>Choose pricelist</DialogTitle>
            <DialogContent dividers={true}>
                <PricelistTree
                    multiSelect={multiSelect}
                    selectedPricelistIds={selectedPricelistIds}
                    pricelistsSelected={handlePricelistsSelected}
                    showBasePricelistsOnly={showBasePricelistsOnly}
                    filter={filter}
                    setFilter={setFilter}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button color="primary" onClick={handleSubmit} disabled={!hasSelectedPricelist}>
                    Select
                </Button>
            </DialogActions>
        </Dialog>
    );
};
